const translation = {
  Authentication: {
    notification: {
      title: "Permissões de notificação",
      terms:
        "Receba notificações do C2S mesmo não estando com nosso sistema aberto. Para isso, basta clicar em 'Aceitar'.",
      agree: "Aceitar",
      disagree: "Não quero receber notificações",
    },
  },
  Login: {
    submit: "Entrar",
    label: {
      email: "Seu e-mail",
      password: "Sua senha",
    },
    errors: {
      email: "Endereço de e-mail inválido",
      auth: "Senha errada ou usuário inválido",
    },
  },
  PasswordRecoveryScreen: {
    title: "Esqueci minha senha",
    message:
      "Insira o seu e-mail para receber o link e as instruções para redefinir sua senha.",
    email: "E-mail",
    submit: "Receber instruções (E-mail)",
    sent: "Enviado",
    recovery_alert: "Link de recuperação enviado para {{email}}",
    errorMessage: "Endereço de e-mail não cadastrado",
    goBack: "Voltar à tela de login",
    label: {
      email: "Seu e-mail",
    },
  },
  Customer: {
    details: {
      createdAt: `Criando em {{date}}`,
      editButtonTitle: "Editar",
      tags: {
        clickToAddTagLabel: "Clique aqui para adicionar uma etiqueta",
      },
      products: {
        title: "Produtos de interesse",
        withoutName: "Produto não nomeado",
        notFound: "não informado",
        sure: "tem certeza de que deseja excluir esse produto?",
        removed: "Produto removido com sucesso",
        removed_error: "Erro ao remover o produto",
        manually_removed:
          "Você só pode deletar os produtos que foram adicionados manualmente",
        add_new: "Adicionar novo produto",
      },
      activity: {
        title: "Atividades",
        action: "AGENDAR ATIVIDADE",
        feedback_customer: "Retornar para o cliente",
        at: "às",
        scheduled_visit: "Visita agendada",
        first_contact: "Primeiro contato",
        schedule_activity: "Agendar atividade",
      },
      archive: {
        action: "ARQUIVAR CONTATO",
        actionSuccess: "Contato arquivado com sucesso",
        actionError: "Falha ao arquivar contato",
      },
      reOpen: {
        filed: "Contato arquivado",
        action: "REATIVAR CONTATO",
        actionSuccess: "Contato reativado com sucesso",
        actionError: "Falha ao reativar contato",
      },
      negotiationDone: {
        title: "Negócios fechados",
      },
    },
    spotlights: {
      activity: {
        title: "Agendar atividade",
        labels: {
          date: "Em qual a data?",
          time: "Em qual o horário?",
          notes: "Notas",
          type: "Qual atividade deseja criar",
          typeVisit: "Visita agendada",
          typeCall: "Retornar para o cliente",
        },
        action: "AGENDAR",
      },
      contact: {
        labels: {
          name: "Nome",
          email: "E-mail",
          phone: "Informe o telefone",
        },
        action: "SALVAR",
        saveSuccess: "Contato atualizado com sucesso",
        saveError: "Ops. Contato não foi atualizado.",
        saveErrorContactTaken: "Ops. {{error_message}}",
      },
      product: {
        labels: {
          name: "Nome",
          reference_code: "Código do produto",
          lead_source: "Fonte",
          channel: "Canal",
          price: "Preço",
          url: "URL",
        },
        action: "SALVAR",
        saveSuccess: "Produto salvo com sucesso",
        saveError: "Ops. Produto não foi atualizado",
      },
    },
  },
  Chat: {
    labels: {
      message: "Digite sua mensagem",
      avatarUnavailable: "Foto de perfil indisponível",
      whatsappAvailable: "WhatsApp válido",
      whatsappUnavailable: "WhatsApp inválido",
      loading: "Carregando...",
      send_msg_error: "Erro ao enviar a mensagem",
      load_msg_error: "Erro ao carregar mais mensagens",
    },
    templateMessages: {
      title: "Mensagens prontas",
    },
    replySources: {
      title: "Canais disponíveis",
      whatsapp: "WhatsApp",
      email: "E-mail",
      mostOne: "Você precisa de ao menos um canal selecionado",
    },
    messageHeader: {
      replyButton: "Responder",
      replyDenied:
        "Você só pode citar mensagens que o cliente enviou por WhatsApp",
    },
    errors: {
      failToSendMessage: "Erro ao enviar mensagem",
      customerNotLoaded:
        "Contato não foi carregado. Por favor, tente mais tarde",
    },
    attachment: {
      maxSize: "Tamanho máximo para arquivos é de 80MB",
      success: "Arquivo enviado com sucesso.",
      error: "Não foi possível enviar o arquivo.",
      title: "Arquivo selecionado",
      send: "Enviar",
      cancel: "Cancelar",
    },
    video_attachment: {
      title: "Videos Selecionados",
      sendButton: "Enviar",
      success: "Video {{current}}/{{total}} enviado com sucesso para {{user}}",
      error: "Video {{current}}/{{total}} não foi enviado para {{user}}",
      sending_queue: "Enviando vídeo {{current}}/{{total}} para {{user}}",
      success_all: "Todos os vídeos enviados com sucesso para {{user}}",
    },
    audio_attachment: {
      recording: "Gravando",
      discard: "Descartar",
      finish: "Finalizar",
      confirm: "Confirma?",
      cancel: "Cancelar",
      send: "Enviar",
      success: "Áudio enviado com sucesso",
      error: "Erro ao enviar o áudio",
    },
    pasteImageModal: {
      title: "Imagem Selecionada",
      send: "Enviar",
    },
  },
  Contacts: {
    tabs: {
      conversations: "A FAZER",
      activities: "ATIVIDADES",
      visits: "VISITAS",
      favorites: "FAVORITOS",
      all: "TODOS",
    },
    messages: {
      type: {
        image: "Imagem",
        video: "Vídeo",
        audio: "Áudio",
        file: "Arquivo",
      },
      resume: {
        first_contact: "Envie a primeira mensagem",
      },
    },
    forwardMode: {
      success: "Contatos encaminhados com sucesso",
      error: "Erro ao encaminhar contatos",
      modalHeader: "Encaminhar contatos",
      confirmationMessage:
        "Deseja encaminhar {{count}} contatos para {{selected_user}} ?",
      confirmButton: "Sim",
      cancelButton: "Não",
      forwardTooltip: "Clique para encaminhar contato",
      selectedContacts: "Contatos selecionados ({{count}})",
      unselectAll: "Desmarcar contatos selecionados",
      forwardAll: "Encaminhar contatos selecionados",
    },
    filter: {
      filtersButton: "Filtros",
      filterModalTitle: "Filtros",
      applyFilterButton: "Filtrar",
      clearFiltersButton: "Limpar Filtros",
      scopeAll: "Todos",
      scopeNotInteracted: "Não interagidos",
      scopeUnreadMessages: "Com novas mensagens",
      noTeam: "Nenhuma equipe",
      noUser: "Nenhum usuário",
      noTag: "Nenhuma etiqueta",
      scopeLabel: "Escopo",
      teamsLabel: "Equipes",
      usersLabel: "Usuários",
      tagsLabel: "Etiquetas",
      teams: "+{{more}} equipes",
      team: "+{{more}} equipe",
      users: " +{{more}} usuários",
      user: "+{{more}} usuário",
      tags: "+{{more}} etiquetas",
      tag: "+{{more}} etiqueta",
    },
  },
  Reports: {
    main: {
      title: "Relatório geral",
      exportReportsButton: "Exportar Relatórios",
      startLabel: "Início",
      endLabel: "Fim",
      updateButton: "Atualizar",
    },
    charts: {
      time_to_interact_title:
        "Relatório de tempo de primeira interação por usuário",
      sold_products_title: "Relatório de produtos vendidos",
      product_by_channels_title: "Relatório de produtos por canal",
      products_by_sources_title: "Relatório de produtos por fonte",
    },
    export: {
      title: "Relatórios para Exportação",
      received_leads: "Leads Recebidos",
      received_leads_description:
        "Contém todos os leads recebidos de todas as fontes, contendo o produto de interesse.",
      customers_csv: "leads_recebidos",
      clients: "Clientes",
      clients_description:
        "Contém todos os cliente únicos, com seus dados de contato.",
      clients_csv: "clientes",
      done_deals: "Negócios Fechados",
      done_deals_description:
        "Contém todos os leads com negócios fechados, com dados do cliente e do produto.",
      sold_products_csv: "negocios_fechados",
      exportButton: "Exportar",
      error_message: "Erro ao exportar relatório, tente novamente.",
    },
  },
  NewCustomer: {
    title: "Criar novo contato",
    labels: {
      contact: {
        name: "Nome",
        email: "E-mail",
        phone: "Telefone",
      },
      product: {
        name: "Nome",
        price: "Preço",
        url: "Link do Anúncio",
        lead_source: "Fonte",
        channel: "Canal",
      },
    },
    action: "Gerar novo contato",
  },
  Users: {
    columns: {
      manager: "Gerente",
      seller: "Usuário",
    },
    header_name: {
      name: "Nome",
      receive_lead: "Recebe Lead?",
      edit: "editar",
      last_sign_in_at: "Último login em",
    },
    titles: {
      user_listing: "Listagem de usuários",
      external_user: "Usuário externo",
    },
    buttons: {
      description: "Criar novo usuário",
      invite: "Reenviar convite",
    },
    update_user: {
      update_text: "Usuário atualizado com sucesso!",
      failed_text: "Erro ao atualizar usuário",
    },
    users_status: {
      active_and_disabled_user: "Usuários ativos e inativos",
      user_active: "Usuário ativo",
      user_desabled: "Usuário inativo",
    },
    teams: {
      team: "Equipe",
    },
    external: {
      external_user: "Usuário externo",
    },
  },
  Credentials: {
    title: "Minhas integrações",
    labels: {},
    status: {
      inChat: "Faça a leitura do código QR pelo celular na opção WhatsApp Web.",
      authenticated: "Autenticado.",
      pending: "Aguardando conexão com o WhatsApp.",
      disabled: "Desativado.",
      enabled: "Ativado. Aguardando a conclusão da configuração da credencial.",
      isLogged: "Celular sem conexão com a internet.",
      notLogged:
        "Não há nenhum WhatsApp conectado, é necessário escanear o código QR pelo celular na opção WhatsApp Web.",
      browserClose: "Navegador foi fechado.",
      qrReadSuccess: "Usuário não logado.",
      qrReadFail: "Error na leitura do Qr Code.",
      autocloseCalled: "O navegador foi fechado.",
      desconnectedMobile:
        "O WhatsApp foi desconectado do celular. Por favor faça a leitura do código QR pelo celular na opção WhatsApp Web.",
      serverClose: "O cliente foi desconectado do wss.",
      deleteToken: "Token removido.",
      chatsAvailable: "Tudo certo. O C2Sgo está conectado ao seu celular.",
      connected: "Tudo certo. O C2Sgo está conectado ao seu celular.",
      deviceNotConnected:
        "Envio e recebimento de mensagens não disponível porque o telefone está desconectado (Tentando conectar ao telefone).",
      disconnected:
        "Envio e recebimento de mensagens não disponível porque o telefone está desconectado (Tentando conectar ao telefone).",
      serverWssNotConnected: "O endereço wss não foi encontrado!",
      noOpenBrowser: "Problema ao consultar o navegador.",
      deviceWasRemoved:
        "O dispositivo do C2Sgo foi removido manualmente pelo usuário do telefone.",
    },
  },
  TagsManager: {
    title: "Etiquetas",
    entryForbidden: "Usuário sem acesso",
    fetchingError: "Erro ao carregar tags",
    tagsUpdated: "Etiquetas atualizadas com sucesso",
    columnsHeader: {
      name: "Nome",
      show: "Exibir",
      origin: "Origem",
      edit: "Editar",
      delete: "Excluir",
    },
    createNewTagButton: "Criar nova etiqueta",
    createdBy: "Criada por",
    addNewTagTitle: "Criar etiqueta",
    editTagTitle: "Editar etiqueta",
    createNewTagTitle: "Nome da Etiqueta",
    editTagNameTitle: "Insira novo nome para etiqueta",
    createNewTagButton: "Criar etiqueta",
    editTagButton: "Editar etiqueta",
    createTagSuccess: "Etiqueta criada com sucesso.",
    editTagSuccess: "Etiqueta editada com sucesso.",
    createTagError: "Erro ao criar etiqueta",
    editTagError: "Erro ao editar etiqueta",
    deleteTagSuccess: "Etiqueta excluída com sucesso.",
    deleteTagError: "Erro ao excluir a etiqueta.",
  },
  common: {
    success: "Sucesso",
    error: "Ops, algum erro aconteceu",
    titles: {
      success: "Sucesso",
      error: "Ocorreu uma falha",
      alert: "Alerta",
      update_available: "Nova versão disponível!",
    },
    messages: {
      empty_prop_ref: "Sem código",
      empty: "Nenhum",
      loading: "Carregando...",
      response_error:
        "Erro na comunicação com o servidor. Verifique sua conexão com a internet ou tente novamente mais tarde.",
      invalid_token: "A usuário selecionado não existe ou é inválido.",
      update_available:
        "Foi disponibilizada uma nova versão do aplicativo. Clique 'Atualizar' para reiniciar e atualizar o aplicativo, ou em 'Mais tarde' para que a atualização seja feita em outro momento.",
    },
    errors: {
      invalid: "não é válido",
      required: "é obrigatório(a)",
      taken: "já está em uso",
      greater_than: "deve ser maior que {{count}}",
      greater_than_or_equal_to: "deve ser maior ou igual a {{count}}",
      less_than: "deve ser menor que {{count}}",
      less_than_or_equal_to: "deve ser menor ou igual a {{count}}",
      too_long: {
        one: "é muito longo (máximo: 1 caracter)",
        other: "é muito longo (máximo: {{count}} caracteres)",
      },
      too_short: {
        one: "é muito curto (mínimo: 1 caracter)",
        other: "é muito curto (mínimo: {{count}} caracteres)",
      },
      without_internet: "Sem conexão com a internet.",
      network_error:
        "Erro na comunicação com o servidor. Verifique sua conexão com a internet ou tente novamente mais tarde.",
    },
    numbers: {
      currency: "{{value, currency}}",
    },
    dates: {
      custom: "{{value, format}}",
      hour: "{{value, LT}}",
      small: "{{value, L}}",
      medium: "{{value, LLL}}",
      large: "{{value, LLLL}}",
      datetime: "{{value, L LT}}",
    },
  },
  Search: {
    searching: "Pesquisando...",
    search_teams: "Pesquisa em todas as equipes",
    result: "Resultado",
  },
  forward: {
    title: "Encaminhar",
    success: "Contato encaminhado com sucesso",
    error: "Erro ao encaminhar contato",
    not_loading: "Não foi possível carregar os usuários",
  },
  Rules: {
    remove: "Regra removida com sucesso",
    updated: "A ordem das regras foi atualizada!",
    error:
      "Para salvar é necessário ter no mínimo uma regra de usuário de segurança",
    order: "Ordem das regras",
    rule_memory: "Regra da memória",
    remove_alert: "Essa regra será REMOVIDA!. Tem certeza?",
    create: "Criar nova regra",
    save: "SALVAR",
  },
  Conect: {
    conected: "Conectado",
    disconected: "Desconectado",
  },
  Widget: {
    whats_news: "Novidades",
  },
};

export default translation;
